const PIXEL_SRC = "https://connect.facebook.net/en_US/fbevents.js";
let pixelId = null;
let loadPromise = null;
let lastPageView = null;

const validId = (v) => typeof v === "string" && /^\d{5,30}$/.test(v);

export function loadMetaPixel(id) {
  if (!validId(id)) return Promise.resolve(false);
  if (pixelId === id && window.fbq) return Promise.resolve(true);
  if (loadPromise) return loadPromise;
  pixelId = id;
  window.fbq = window.fbq || function () {
    window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
  };
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = "2.0";
  window.fbq.queue = [];
  window.fbq("init", id);
  loadPromise = new Promise((resolve) => {
    if (document.querySelector('script[data-meta-pixel="true"]')) { resolve(true); return; }
    const s = document.createElement("script");
    s.async = true;
    s.src = PIXEL_SRC;
    s.dataset.metaPixel = "true";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return loadPromise;
}

export function trackPageView(path) {
  if (!window.fbq || !pixelId || lastPageView === path) return;
  lastPageView = path;
  window.fbq("track", "PageView");
}

export function trackLead() {
  if (window.fbq && pixelId) window.fbq("track", "Lead");
}
